import {
    BrowserUtils,
    ComponentElements,
    ComponentInjector,
    ComponentObject,
    ComponentSelector,
    ComponentSelectors,
    ComponentService,
    Inject,
    UIComponent
} from '@atypon/ui-utils';

class Texts extends ComponentObject {
}

class ClassList extends ComponentObject {
}

class Selectors extends ComponentSelectors {
    addRangeFields = new ComponentSelector('.ip-ranges__add-range input[name="ipRanges"]');
    addRangeSubmitButtons = new ComponentSelector('.ip-ranges__add-range input[type="submit"]');
    updateRangesCheckboxes = new ComponentSelector('.ip-ranges__update-range tr:not(.ip-ranges__update-range__ignore-conflicts) input[type="checkbox"]');
    updateRangesSubmitButtons = new ComponentSelector('.ip-ranges__update-range input[type="submit"]');
}

class Elements extends ComponentElements<Selectors> {
    addRangeFields: Array<HTMLInputElement> = [];
    addRangeSubmitButtons: Array<HTMLButtonElement> = [];
    updateRangesCheckboxes: Array<HTMLInputElement> = [];
    updateRangesSubmitButtons: Array<HTMLButtonElement> = [];
}

interface ipRanges extends ComponentService<Selectors, Elements, ClassList, Texts> {
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class ipRanges implements UIComponent {
    @Inject()
    protected browserUtils: BrowserUtils;

    constructor(readonly wrapper: HTMLElement) {
    }

    initialize(): void {
        this.elements.initialize(this.wrapper);
        this.addEventListeners();
    }

    addEventListeners(): void {
        this.elements.addRangeFields.forEach((field) => {
            field.addEventListener('input', this.handleAddRangeFieldChange.bind(this, field));
        });
        this.elements.updateRangesCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', this.handleUpdateRangeFieldChange.bind(this, checkbox));
        });
    }

    protected handleAddRangeFieldChange(): void {
        const anyIsEmpty = this.elements.addRangeFields.some(field => field.value.trim() === '');
        this.setSubmitButtonsDisable(this.elements.addRangeSubmitButtons, anyIsEmpty)
    }

    protected handleUpdateRangeFieldChange(): void {
        const anyIsChecked = this.elements.updateRangesCheckboxes.some(checkbox => checkbox.checked);
        this.setSubmitButtonsDisable(this.elements.updateRangesSubmitButtons, !anyIsChecked)
    }

    protected setSubmitButtonsDisable(array: Array<HTMLButtonElement> = [], isDisabled: boolean): void {
        array.forEach(button => {
            button.disabled = isDisabled;
        })
    }
}

export default ipRanges;

export {
    Elements as IpRangesElements,
    Selectors as IpRangesSelectors,
    ClassList as IpRangesClassList,
    Texts as IpRangesTexts,
}